import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPandadoc = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "30px",
	height: "30px",
	viewBox: "0 0 30 30",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group",
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("polygon", {
				id: "Path",
				fill: "#47B972",
				points: "0 0 30 0 30 30 0 30"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M22,11 L21.92,11 C21.2105286,10.4109069 20.3119063,10.0983427 19.39,10.12 C18.0931902,10.1016006 16.8537375,10.6536872 16,11.63 L17.23,13 C17.8012825,12.3999051 18.5914912,12.0571206 19.42,12.05 C20.1833111,12.0664563 20.9057057,12.3983659 21.4154049,12.9668036 C21.925104,13.5352413 22.1765677,14.2894191 22.11,15.05 C22.1774445,15.8226099 21.9167158,16.5879459 21.3916259,17.1586958 C20.866536,17.7294457 20.1255426,18.0529382 19.35,18.05 C15.19,18.05 16.35,10.22 10.77,10.22 C9.49488967,10.1923283 8.26394025,10.6873763 7.36303364,11.5901716 C6.46212703,12.492967 5.96965799,13.7249504 6,15 L6,23.5 L8,23.5 L8,19 L8.08,19 C8.79308621,19.5815543 9.69005575,19.8899984 10.61,19.87 C11.9230463,19.9152073 13.1878743,19.3726144 14.06,18.39 L12.77,17 C12.1987175,17.6000949 11.4085088,17.9428794 10.58,17.95 C9.81567532,17.9364975 9.09146161,17.6054573 8.5811246,17.0363083 C8.0707876,16.4671592 7.82038584,15.7112676 7.89,14.95 C7.82255547,14.1773901 8.08328417,13.4120541 8.6083741,12.8413042 C9.13346402,12.2705543 9.87445744,11.9470618 10.65,11.95 C14.81,11.95 13.65,19.78 19.24,19.78 C20.5249997,19.8085534 21.7647327,19.3050931 22.6659838,18.3886949 C23.567235,17.4722966 24.0499646,16.2243454 24,14.94 L24,6.5 L22,6.5 L22,11 Z",
				id: "Path",
				fill: "#FFFFFF"
			})]
		})
	})
});
export default SvgPandadoc;
